import React from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useColorModeValue
} from "@chakra-ui/react";
import { BiChevronDown } from "react-icons/bi";
import { TrafficViolationSpecificActions } from "./TrafficViolationSpecificActions";

const TrafficViolationSpecificMenu = ({ row, t, navigate, handlePrintAit, handlePrintNa, handlePrintNp, handleUndoCancel, handleUndoDefer }) => {
  const actions = TrafficViolationSpecificActions(t, navigate, handlePrintAit, handlePrintNa, handlePrintNp, handleUndoCancel, handleUndoDefer).filter(action => action.visible(row));

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={<BiChevronDown />}
        aria-label={t("system.labels.actions")}
        colorScheme="blue"
        border={`solid 0.1em ${useColorModeValue("#718096", "#4A5568")}`}
        w="40px"
        minW={{ base: "30px", md: "40px" }}
        h="35px"
        onClick={(e) => e.stopPropagation()}
        onDoubleClick={(e) => e.stopPropagation()}
      />
      <MenuList maxHeight="300px" overflowY="auto">
        {actions.map((action, index) => (
          <MenuItem
            key={index}
            color={useColorModeValue("gray.700", "white")}
            icon={
              <Box fontSize="lg" display="flex" alignItems="center">
                {action.icon}
              </Box>
            }
            onClick={(e) => {
              e.stopPropagation();
              action.onClick({ original: row.original });
            }}
          >
            {action.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default TrafficViolationSpecificMenu;